<template>
  <nav class="bg-[#591E91] w-full fixed top-0 left-0 right-0 z-50">
    <div class="container mx-auto flex items-center justify-between max-w-7xl py-3 px-4">

      <!-- Logo + botão back -->
      <div class="flex items-center space-x-2 min-w-[120px] sm:min-w-[140px]">
        <button v-if="$route.path !== localePath('/gamificacao/home')"
                @click="$router.back()" class="text-white hover:text-[#EE9F12] flex-shrink-0">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 sm:h-7 sm:w-7" fill="none" viewBox="0 0 24 24"
               stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7" />
          </svg>
        </button>
        <router-link :to="localePath('/gamificacao/home')" class="flex-shrink-0">
          <img src="@/assets/logo.png" alt="Logo" class="h-10 sm:h-12 md:h-14" />
        </router-link>
      </div>

      <!-- Links (centralizados) - apenas desktop -->
      <div class="hidden lg:flex flex-1 justify-center">
        <ul class="font-medium flex flex-row space-x-4 xl:space-x-6 items-center">
          <router-link :to="localePath('/gamificacao/home')" class="text-white hover:text-[#EE9F12] px-2 xl:px-3 py-2 whitespace-nowrap">
            {{ tr.home }}
          </router-link>
          <router-link :to="localePath('/gamificacao/projects')" class="text-white hover:text-[#EE9F12] px-2 xl:px-3 py-2 whitespace-nowrap">
            {{ tr.games }}
          </router-link>
          <router-link :to="localePath('/gamificacao/news')" class="text-white hover:text-[#EE9F12] px-2 xl:px-3 py-2 whitespace-nowrap">
            Blog
          </router-link>
          <a
              href="https://mitogames.com.br/home"
              target="_blank"
              rel="noopener noreferrer"
              class="flex items-center text-white hover:text-[#EE9F12] px-2 xl:px-3 py-2 whitespace-nowrap"
          >
            <span>Entretenimento</span>
          </a>
          <a href="#" @click.prevent="navigateTo('AboutSection')" class="text-white hover:text-[#EE9F12] px-2 xl:px-3 py-2 whitespace-nowrap">
            {{ tr.aboutUs }}
          </a>
          <a href="#" @click.prevent="navigateTo('ContactSection')" class="text-white hover:text-[#EE9F12] px-2 xl:px-3 py-2 whitespace-nowrap">
            {{ tr.contact }}
          </a>
        </ul>
      </div>

      <!-- PESQUISA GLOBAL (desktop) -->
      <div class="hidden lg:flex items-center min-w-[200px] xl:min-w-[230px] justify-end">
        <div class="relative flex-shrink-0 w-full max-w-[250px]">
          <div class="flex items-center rounded-lg bg-[#500387] px-3 py-2 xl:py-3">
            <input
                v-model="searchQuery"
                @keyup.enter="goToSearch"
                type="text"
                class="outline-none bg-[#500387] text-white w-full text-sm xl:text-base"
                placeholder="Pesquisar"
            />
            <button @click="goToSearch" class="ml-2 text-[#EE9F12] flex-shrink-0">
              <svg class="w-4 h-4 xl:w-5 xl:h-5" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"
                   stroke-linecap="round" stroke-linejoin="round">
                <path d="M21 21l-4.35-4.35"></path>
                <circle cx="10" cy="10" r="6"></circle>
              </svg>
            </button>
          </div>
        </div>
      </div>

      <!-- Mobile: Hamburguer -->
      <button @click="showMenu = !showMenu" class="lg:hidden text-[#EE9F12] focus:ring-2 p-2 rounded-lg ml-2 flex-shrink-0">
        <svg v-if="!showMenu" class="w-7 h-7 sm:w-8 sm:h-8" fill="none" viewBox="0 0 17 14">
          <path d="M1 1h15M1 7h15M1 13h15" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
        </svg>
        <svg v-else class="w-7 h-7 sm:w-8 sm:h-8" fill="none" viewBox="0 0 17 17">
          <path fill="currentColor" d="M14.6 14.6c.6-.6.6-1.5 0-2.1L10.9 8.8l3.7-3.7c.6-.6.6-1.5 0-2.1-.6-.6-1.5-.6-2.1 0L8.8 6.7 5 2.9c-.6-.6-1.5-.6-2.1 0s-.6 1.5 0 2.1l3.7 3.7-3.7 3.7c-.6.6-.6 1.5 0 2.1.6.6 1.5.6 2.1 0l3.7-3.7 3.7 3.7c.6.6 1.5.6 2.1 0z"/>
        </svg>
      </button>
    </div>

    <!-- Mobile menu: Menus e pesquisa -->
    <div v-if="showMenu" class="lg:hidden px-4 pb-4 bg-[#591E91] border-t border-[#500387]">
      <ul class="font-medium flex flex-col items-center space-y-2 mb-4">
        <router-link :to="localePath('/gamificacao/home')" class="text-white hover:text-[#EE9F12] px-3 py-2 w-full text-center" @click="showMenu = false">
          {{ tr.home }}
        </router-link>
        <router-link :to="localePath('/gamificacao/projects')" class="text-white hover:text-[#EE9F12] px-3 py-2 w-full text-center" @click="showMenu = false">
          {{ tr.games }}
        </router-link>
        <router-link :to="localePath('/gamificacao/news')" class="text-white hover:text-[#EE9F12] px-3 py-2 w-full text-center" @click="showMenu = false">
          Blog
        </router-link>
        <a href="https://mitogames.com.br/home" target="_blank" rel="noopener noreferrer" class="text-white hover:text-[#EE9F12] px-3 py-2 w-full text-center" @click="showMenu = false">
          Entretenimento
        </a>
        <a href="#" @click.prevent="navigateTo('AboutSection'); showMenu = false" class="text-white hover:text-[#EE9F12] px-3 py-2 w-full text-center">
          {{ tr.aboutUs }}
        </a>
        <a href="#" @click.prevent="navigateTo('ContactSection'); showMenu = false" class="text-white hover:text-[#EE9F12] px-3 py-2 w-full text-center">
          {{ tr.contact }}
        </a>
      </ul>

      <div class="w-full max-w-sm mx-auto">
        <div class="flex items-center rounded-lg bg-[#500387] px-3 py-3">
          <input
              v-model="searchQuery"
              @keyup.enter="goToSearch"
              type="text"
              class="outline-none bg-[#500387] text-white flex-1 min-w-0 text-sm"
              placeholder="Pesquisar"
          />
          <button @click="goToSearch" class="ml-2 text-[#EE9F12] flex-shrink-0">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"
                 stroke-linecap="round" stroke-linejoin="round">
              <path d="M21 21l-4.35-4.35"></path>
              <circle cx="10" cy="10" r="6"></circle>
            </svg>
          </button>
        </div>
      </div>
    </div>
  </nav>
</template>

<script setup>
import {ref, computed} from 'vue';
import {useRoute, useRouter} from 'vue-router';

const props = defineProps({
  language: {type: String, default: 'pt'}
});

const route = useRoute();
const router = useRouter();
const showMenu = ref(false);
const searchQuery = ref('');

const translations = {
  pt: {home: 'Home', games: 'Jogos', aboutUs: 'Quem somos', contact: 'Contato'},
  en: {home: 'Home', games: 'Games', aboutUs: 'About Us', contact: 'Contact'}
};
const tr = computed(() => translations[props.language] || translations.pt);

function localePath(path) {
  return props.language === 'en' ? `/en${path}` : path;
}

function navigateTo(sectionId) {
  const dest = localePath('/gamificacao/home');
  if (route.path !== dest) {
    router.push({path: dest, hash: `#${sectionId}`});
  } else {
    const el = document.querySelector(`#${sectionId}`);
    el && el.scrollIntoView({behavior: 'smooth', block: 'start'});
  }
}

function goToSearch() {
  if (searchQuery.value.trim().length > 0) {
    router.push({path: '/search', query: {q: searchQuery.value.trim()}});
    searchQuery.value = '';
    showMenu.value = false;
  }
}
</script>
